const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 71 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Forma-1",
    serifId: "Forma 1",
    transform: "matrix(1,0,0,1,-746,-259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M790.174,302.257C790.088,297.081 789.387,295.606 784.017,294.672C784.017,294.672 783.261,295.6 781.5,295.6C779.738,295.6 778.982,294.672 778.982,294.672C773.671,295.596 772.927,297.049 772.829,302.089C772.821,302.5 772.817,302.522 772.815,302.474C772.816,302.564 772.816,302.729 772.816,303.018C772.816,303.018 774.095,305.501 781.5,305.501C788.905,305.501 790.183,303.018 790.183,303.018C790.183,302.832 790.183,302.703 790.183,302.616C790.182,302.645 790.179,302.588 790.174,302.257ZM790.183,302.616C790.186,302.566 790.184,302.272 790.183,302.616L790.183,302.616ZM781.5,294.259C784.039,294.259 786.097,291.851 786.097,288.879C786.097,285.908 785.421,283.499 781.5,283.499C777.578,283.499 776.902,285.908 776.902,288.879C776.902,291.851 778.96,294.259 781.5,294.259Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.fb54d227cb7f1cb600e72a0d5c6f0db7.svg";
export { ForwardRef as ReactComponent };